import { useMutation } from '@tanstack/react-query';
import { cancelDraft } from '../../services';

export function useCancelDraft() {
  return useMutation(cancelDraft, { onSuccess: (data) => data });
}
